import { PlanSibling } from '@anm/api/modules/pricing';
import { SelectOption } from '@anm/components/select/Select';
import { FC } from 'react';
import styled from 'styled-components';

import Dropdown from './Dropdown';

const Wrapper = styled.div``;

export type PlanSiblingDropdownProps = {
  value: PlanSibling;
  options: PlanSibling[];
  onChange: (value: PlanSibling) => void;
};

const PlanSiblingDropdown: FC<PlanSiblingDropdownProps> = ({ value, options, onChange }) => {
  const optionsMap = options.map<SelectOption<PlanSibling>>(item => ({ label: item.name, value: item }));
  return (
    <Wrapper>
      <Dropdown
        current={{ label: value.name, value }}
        options={optionsMap}
        onChange={({ value }) => value && onChange(value)}
      />
    </Wrapper>
  );
};

export default PlanSiblingDropdown;
